<dz-card [cardOptions]="cardOptions">
	<dz-card-title>
		<ng-content></ng-content>
	</dz-card-title>
</dz-card>
